import { Button, HStack, Text } from '@chakra-ui/react';
import { Table as TableType } from '@tanstack/react-table';
import _ from 'lodash';
import React from 'react';
import { v4 as uuidV4 } from 'uuid';

import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

const getCurrentPageOffset = ({
  NextToken,
  PreviousToken,
  paginationTokens,
  offset = 10,
}: {
  NextToken?: string;
  PreviousToken?: string;
  paginationTokens?: string[];
  offset?: number;
}): number => {
  if (!paginationTokens) {
    return 0;
  }

  if (NextToken) {
    const nextPageIndex = paginationTokens?.indexOf(NextToken);
    const offsetMultipler =
      nextPageIndex !== undefined && Boolean(nextPageIndex >= 0)
        ? nextPageIndex // -1 to get current page, but need to +1 to convert index -> offsetMultipler
        : 0;
    return offsetMultipler * offset;
  }
  if (PreviousToken) {
    const previousPageIndex = paginationTokens?.indexOf(PreviousToken);
    const offsetMultipler =
      previousPageIndex !== undefined && Boolean(previousPageIndex >= 0)
        ? previousPageIndex + 2 // +1 to get current page, but need to +1 to convert index -> offsetMultipler
        : 0;
    return offsetMultipler * offset;
  }
  return 0;
};

const createNumberArray = ({
  arrayLength,
  // PreviousToken,
  // NextToken,
  offset,
}: {
  arrayLength: number;
  offset: number;
  PreviousToken?: string;
  NextToken?: string;
}): Array<string | number> => {
  const pageNumberArray: Array<string | number> = Array.from(
    Array(arrayLength).keys(),
  ).map((i) => i + 1 + offset);
  // TODO implement next pagination/ previous pagination token
  // if (PreviousToken) {
  //   pageNumberArray.unshift('...');
  // }
  // if (NextToken) {
  //   pageNumberArray.push('...');
  // }

  return pageNumberArray;
};

const scrollToTopOfTable = () => {
  document
    .getElementById('receivables-dashboard-main-table')
    ?.scroll({ top: 0 });
};

export const ReceivablesTablePaginationControl: React.FC<{
  table: TableType<any>;
  NextToken?: string;
  PreviousToken?: string;
  paginationTokens: string[];
}> = ({ table, NextToken, PreviousToken, paginationTokens }) => {
  const pageCount = table.getPageCount();
  const currentPage = table.getState().pagination.pageIndex + 1;
  const pages = createNumberArray({
    arrayLength: pageCount,
    PreviousToken,
    NextToken,
    offset: getCurrentPageOffset({
      NextToken,
      PreviousToken,
      paginationTokens,
    }),
  });
  return (
    <HStack w="100%" spacing="8px" justifyContent="center" p="32px 0">
      <Button
        leftIcon={<FaIcon icon="chevron-left" />}
        colorScheme="aurora"
        variant="ghost"
        isDisabled={
          // currentPage === 1 && Boolean(PreviousToken)
          //   ? false
          // :
          !table.getCanPreviousPage()
        }
        onClick={() => {
          scrollToTopOfTable();
          table.previousPage();
        }}
      >
        Prev
      </Button>
      {pages.length > 0 &&
        _.map(pages, (pageNumber) =>
          _.isNumber(pageNumber) ? (
            <Button
              colorScheme={currentPage === pageNumber ? undefined : 'aurora'}
              variant={currentPage === pageNumber ? 'solid' : 'ghost'}
              onClick={() => {
                scrollToTopOfTable();
                table.setPageIndex(pageNumber - 1);
              }}
              key={_.isNumber(pageNumber) ? pageNumber : uuidV4()}
            >
              {pageNumber}
            </Button>
          ) : (
            <Text key={uuidV4()}>...</Text>
          ),
        )}
      {pages.length === 0 && (
        <Button isDisabled variant="ghost">
          1
        </Button>
      )}
      <Button
        rightIcon={<FaIcon icon="chevron-right" />}
        colorScheme="aurora"
        variant="ghost"
        onClick={() => {
          scrollToTopOfTable();
          table.nextPage();
        }}
        isDisabled={
          // Boolean(NextToken) && currentPage === pageCount
          //   ? false
          // :
          !table.getCanNextPage()
        }
      >
        Next
      </Button>
    </HStack>
  );
};
